import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/banner-trabajadores/trabajadores_v2.png")